import { LocationOn, WorkspacePremium, Public, Verified } from '@mui/icons-material';

export const ABOUT_SECTION_ID = 'about-section-container';

export const DEFAULT_TITLE = 'About Us';

export const DEFAULT_SUBTITLE = 'Precision. Presence. Prestige.';

export const DEFAULT_PARAGRAPHS = [
  'We are a Dubai-based logistics house delivering bespoke customs brokerage, premium freight forwarding, and quietly impeccable cross-border solutions.',
  'We combine seasoned expertise with subtle tech to move high-value shipments with discretion, speed, and finesse.',
];

export const DEFAULT_HIGHLIGHTS = [
  { label: 'HQ', value: 'Dubai' },
  { label: 'Service', value: 'White-glove' },
  { label: 'Reach', value: '100+ countries' },
  { label: 'Authority', value: 'Licensed brokers' },
];

export const ABOUT_IMAGE = `${process.env.PUBLIC_URL}/assets/logo/wall_mockup.jpg`;

export const ICON_MAP = {
  HQ: <LocationOn fontSize="small" />,
  Service: <WorkspacePremium fontSize="small" />,
  Reach: <Public fontSize="small" />,
  Authority: <Verified fontSize="small" />,
};

export const ABOUT_CTA = [
  {
    label: 'Contact Us',
    variant: 'contained',
    targetId: 'contact-container',
  },
  {
    label: 'Our Services',
    variant: 'outlined',
    targetId: 'service-container',
  },
];
